
// eslint-disable-next-line import/no-anonymous-default-export
export default props => props.condition ? props.children : null